import React, { useState, useEffect } from "react";

/** Components */
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, TablePagination, Checkbox, Button, TableFooter, TextField, ButtonGroup, Collapse, Tooltip } from "@mui/material";
import EditUser from "./edituser.component";
import CreateUser from "./createuserbutton.component";
import SelectStatusButton from "../../commons/SelectStatusButton";
import LoadingProgress from "../../commons/LoadingProgress.component";
import { FilterBy } from "./../../commons/filter.component";

/** Icons */
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getCustomers, getGroupUsers, getOrganizationData, getUsers, updateUserStatus } from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";

/** Hook */
import { useDispatch } from "react-redux";

const initialFilter = {
  email: "",
  customer: null,
  organization: null,
  usergroup: null,
};

const User = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  // state
  const [isAllow, setAllow] = useState(true);
  const [changeIds, setChangeIds] = useState([]);
  const [users, setUsers] = useState(undefined);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState(null);
  //filter
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };

  const handleUpdateStatus = (selectedStatus) => {
    return updateUserStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setUsers((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN NGƯỜI DÙNG"));
    getUsers().then((res) => {
      if (res.code === 403) {
        setUsers([]);
        setAllow(false);
        return;
      }
      setUsers(res.data || []);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPage(0);
  }, [filter]);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setSelectedRow(false)}>
            <Tooltip title="Tạo mới">
              <AddIcon />
            </Tooltip>
          </Button>
          <Button onClick={() => setOpen((prev) => !prev)}>
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isOpen} sx={{ marginBottom: "20px" }}>
        <TextField label="Email" value={filter.email} onChange={(e) => setFilter((prev) => ({ ...prev, email: e.target.value }))} style={{ margin: "5px" }} />
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getCustomers({ status: 1 })}
          value={filter.customer || null}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, customer: newValue }))}
          label={t("Khách hàng")}
        />
        <FilterBy
          label="Tổ chức"
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getOrganizationData({ status: 1 })}
          value={filter.organization}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, organization: newValue }))}
        />
        <FilterBy
          label="Nhóm người dùng"
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getGroupUsers({ status: 1 })}
          value={filter.usergroup}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, usergroup: newValue }))}
        />
      </Collapse>
      {!users ? (
        <LoadingProgress />
      ) : (
        <div>
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    ID
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Tên người dùng")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    Email
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Tổ chức")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Phòng/ban")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Tên nhóm")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Khách hàng")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.length ? (
                  users
                    .filter(
                      (item) =>
                        item.email.contains(filter.email) &&
                        (!filter.customer ? true : filter.customer.id === item.customer_id) &&
                        (!filter.organization ? true : filter.organization.id === item.organization_id) &&
                        (!filter.usergroup ? true : filter.usergroup.id === item.usergroup_id)
                    )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .sort((item1, item2) => item1.id - item2.id)
                    .map((row, index) => {
                      return (
                        <TableRow role="checkbox" tabIndex={-1} key={row.id} onClick={(e) => e.target.type !== "checkbox" && setSelectedRow(row)} hover style={{ cursor: "pointer" }}>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                            {row.id}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                            {row.name}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                            {row.email}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                            {row.organization}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                            {row.department_name}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                            {row.usergroup}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                            {row.customer}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                            <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={20}>
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    count={
                      users.filter(
                        (item) =>
                          item.email.contains(filter.email) &&
                          (!filter.customer ? true : filter.customer.id === item.customer_id) &&
                          (!filter.organization ? true : filter.organization.id === item.organization_id) &&
                          (!filter.usergroup ? true : filter.usergroup.id === item.usergroup_id)
                      ).length
                    }
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>
      )}
      <EditUser
        initialData={selectedRow}
        onClose={() => setSelectedRow(null)}
        onSaveResponse={(res) => res.code === 200 && setUsers((prev) => prev.map((item) => (item.id === res.user.id ? res.user : item)))}
      />
      <CreateUser open={selectedRow === false} onClose={() => setSelectedRow(null)} onCreateResponse={(res) => res.code === 200 && setUsers((prev) => [...prev, res.user])} />
    </div>
  );
};

export default User;
